import { __rest } from 'tslib';
import { jsx } from 'react/jsx-runtime';
import { useMemo, useCallback } from 'react';
import { useDropdown } from '../context/DropdownProvider.js';
import '../../BaseDropdown/BaseDropdown.js';
import { isRefCallback } from '../../BaseDropdown/types.js';
import VirtualizedMenuList from '../../BaseDropdown/components/VirtualizedMenuList.js';

const DIVIDER_SIZE = 9;
const PADDING = 4;
const MenuList = (_a) => {
    var { children, innerProps, innerRef, options } = _a, rest = __rest(_a, ["children", "innerProps", "innerRef", "options"]);
    const { menuListRef, hasShadow, size, onCreate, 'data-testid': testId } = useDropdown();
    const creatable = !!onCreate;
    const containerProps = useMemo(() => {
        return Object.assign(Object.assign({}, innerProps), { 'data-testid': `${testId}-menu` });
    }, [testId, innerProps]);
    const itemCount = children.length || 1;
    const itemHeight = size === 'large' ? 36 : 22;
    const getItemSize = useCallback((index) => {
        if (!children) {
            return 0;
        }
        const isEndItem = index === itemCount - 1;
        let size = itemHeight;
        // Fixing the type here is super challenging :)
        const { props } = children[index];
        // @ts-ignore
        const { dividerTop, dividerBottom } = (props === null || props === void 0 ? void 0 : props.data) || {
            dividerTop: false,
            dividerBottom: false,
        };
        const option = options[index];
        // If this is an option group
        if (option != null && 'options' in option) {
            size *= props.options.length + 1;
            size += 1;
        }
        if (index === 0 || isEndItem) {
            size += PADDING;
        }
        if (dividerTop) {
            size += DIVIDER_SIZE;
        }
        if (dividerBottom && !isEndItem) {
            size += DIVIDER_SIZE;
        }
        return size;
    }, [itemHeight, children, itemCount, options]);
    return (jsx(VirtualizedMenuList, Object.assign({}, rest, { options: options, withBottomShadow: hasShadow && creatable, innerProps: containerProps, getItemSize: getItemSize, baseItemHeight: itemHeight, innerRef: ref => {
            menuListRef.current = ref;
            if (isRefCallback(innerRef)) {
                innerRef(ref);
            }
        }, maxHeight: 200 }, { children: children })));
};

export { MenuList as default };
//# sourceMappingURL=MenuList.js.map
